import { render, staticRenderFns } from "./MenuCamion.vue?vue&type=template&id=db851f26&scoped=true&"
import script from "./MenuCamion.vue?vue&type=script&lang=js&"
export * from "./MenuCamion.vue?vue&type=script&lang=js&"
import style0 from "./MenuCamion.vue?vue&type=style&index=0&id=db851f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db851f26",
  null
  
)

export default component.exports